import { useEffect, useState } from 'react';

export function useVehicleChartSensorsState(initialValue) {
  const key = 'sensorsForChart';
  const [state, setState] = useState(() => {
    try {
      const saved = sessionStorage.getItem(key);
      return saved ? JSON.parse(saved) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(state));
  }, [state]);

  return [state, setState];
}

export default useVehicleChartSensorsState;
